require('./accountSettlements.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const classnames = require('classnames');
// @ commons
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { LabelFilterRange } = require('commonsComponents/labelFilterRange');
// @ components
const { LoadingSection } = require('commonsComponents/loadingSection');
const { LastMovementsTable } = require('commonsComponents/lastMovementsTable');
const { AccountSettlementsTableRow } = require('./accountSettlementsTableRow/accountSettlementsTableRow');
const { EmptyState } = require('commonsComponents/emptyState');
const AccountSettlementsFilter = require('components/accounts/accountSettlements/accountSettlementsFilter/accountSettlementsFilter');
// @ actions
const accountsSettlementsActions = require('actions/accountSettlements');
//@utilities
const DateHelper = require('utilities/dateHelper');
//@constants
const { DATE_FILTER_NONE } = require('constants/index');
const { LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY } = require('constants/commonsComponents');
const language = getLanguage();

class AccountSettlements extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showFiltersModal: false
        };

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleNextPageRequestClick = this.handleNextPageRequestClick.bind(this);
        this.handleToggleFiltersModal = this.handleToggleFiltersModal.bind(this);
        this.applyFilters = this.applyFilters.bind(this);
        this.handleClearFilter = this.handleClearFilter.bind(this);
    }

    componentDidMount() {
        const { accountId, requestAccountsSettlements } = this.props;
        requestAccountsSettlements(accountId);
    }

    componentWillUnmount() {
        this.props.clearFilter();
    }

    applyFilters(filters) {
        const { accountId, requestAccountsSettlements, setFilter } = this.props;
        setFilter(filters);
        requestAccountsSettlements(accountId);
    }

    buildContent(immSettlementsAccount) {
        const { accountId, immSettlements } = this.props;

        if (immSettlementsAccount.get('error')) {
            const iconType="nointernet-banking";
            return this.buildEmptyState(accountId, 'accountSettlements-emptyStateErrorMessage', iconType);
        }

        if (immSettlementsAccount.get('loading')) {
            return <LoadingSection />;
        }

        if (
            immSettlementsAccount.get('byOrder').count() === 0 &&
            immSettlements.getIn(['filters', 'date', 'isActive'])
        ) {
            const iconType = "search-banking";
            return this.buildEmptyState(accountId, 'accountSettlements-noResults', iconType);
        }

        if (immSettlementsAccount.get('byOrder').count() === 0) {
            return this.buildEmptyState(accountId, 'accountSettlements-emptyStateEmptyMessage', 'search-banking');
        }

        return this.buildTable();
    }

    buildEmptyState(accountId, messageKey, iconType) {
        const linkText = formatText('accountSettlements-mainButton').toUpperCase();
        const linkURL = `/myprofile/accounts`;

        return (
            <EmptyState
                primaryText={formatText(messageKey)}
                linkText={linkText}
                linkURL={linkURL}
                iconType={iconType}
            />
        );
    }

    buildFilterLabels() {
        const { immSettlements } = this.props;
        const immFilters = immSettlements.get('filters');
        const dateTo = DateHelper.formatDate(immFilters.getIn(['date', 'to']));
        const dateFrom = DateHelper.formatDate(immFilters.getIn(['date', 'from']));

        return (
            <LabelFilterRange
                from={dateFrom}
                to={dateTo}
                closeCallback={() => {
                    this.handleClearFilter();
                }}
            />
        );
    }

    buildNextPageLink() {
        const { immSettlements, accountId } = this.props;
        const immAccountSettlements = immSettlements.get(accountId);
        let content;
        if (immAccountSettlements.get('isFetchingNextPage')) {
            content = <LoadingSection />;
        } else {
            return (
                <div className="text-right">
                    <OKButton
                        onClick={this.handleNextPageRequestClick}
                        modifier="link-complementary"
                    >
                        <FormattedText
                            value="accountSettlements-loadMoreSettlements"
                        />
                    </OKButton>
                </div>
            );
        }

        return content;
    }

    buildTableHead() {
        const { immScreen } = this.props;

        let tableHead;

        if (immScreen.get('isMobile')) {
            tableHead = (
                <thead>
                    <OKTableRow asHeader={true} className="account-settlements__table-header-row-line">
                        <OKTableCell
                            asHeader={true}
                            className="account-settlements__table-header-cell-line"
                            colSpan={2}
                        />
                    </OKTableRow>
                </thead>
            );
        } else {
            tableHead = (
                <thead>
                    <OKTableRow asHeader={true}>
                        <OKTableCell asHeader={true}>
                            <FormattedText value="accountSettlements-period" />
                        </OKTableCell>
                        <OKTableCell
                            asHeader={true}
                            className="account-settlements__table-cells-header--right"
                        >
                            <FormattedText
                                value="accountSettlements-dueAmount"
                                format="firstUppercase"
                            />
                        </OKTableCell>
                        <OKTableCell
                            asHeader={true}
                            className="account-settlements__table-cells-header--right"
                        >
                            <FormattedText
                                value="accountSettlements-creditAmount"
                                format="firstUppercase"
                            />
                        </OKTableCell>
                    </OKTableRow>
                </thead>
            );
        }

        return tableHead;
    }

    buildTable() {
        const {
            accountId,
            immScreen,
            immSettlements,
        } = this.props;

        const immAccountSettlements = immSettlements.get(accountId);
        const tableHead = this.buildTableHead();
        const columns = immScreen.get('isMobile') ? 2 : 3; 

        return (
            <LastMovementsTable
                groupByDate={false}
                rowComponent={AccountSettlementsTableRow}
                immTransactionsByOrder={immAccountSettlements.get('byOrder')}
                immTransactionsById={immAccountSettlements.get('byId')}
                columnsCount={columns}
                id="account-settlements"
                currentMonthKey={LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY}
                language={language}
            >
                {tableHead}
            </LastMovementsTable>
        );
    }

    handleClearFilter() {
        const { accountId, requestAccountsSettlements, clearFilter } = this.props;
        clearFilter();
        requestAccountsSettlements(accountId);
    }

    handleNextPageRequestClick() {
        this.props.requestSettlementsNextPage(this.props.accountId);
    }

    handleToggleFiltersModal() {
        this.setState({
            showFiltersModal: !this.state.showFiltersModal
        });
    }

    render() {
        const { immSettlements, accountId } = this.props;
        const immSettlementsAccount = immSettlements.get(accountId);
        const headerTitle = formatText('accountSettlements-lastSettlements');
        const immDateFilter = immSettlements.getIn(['filters', 'date']);
        const hasFilterApplied = immDateFilter.get('selected') !== DATE_FILTER_NONE;
        const headerClasses = classnames('account-settlements__title', {
            'account-settlements__title--has-filters': hasFilterApplied
        });

        let content = <LoadingSection />;
        let requestNextPageButton;
        let filtersModal;
        let filterLabels;

        if (hasFilterApplied) {
            filterLabels = this.buildFilterLabels();
        }

        if (immSettlementsAccount) {
            content = this.buildContent(immSettlementsAccount);
            filtersModal = (
                <AccountSettlementsFilter
                    applyFilters={this.applyFilters}
                    immFilters={immDateFilter}
                    isOpen={this.state.showFiltersModal}
                    onClose={this.handleToggleFiltersModal}
                />
            );

            if (immSettlementsAccount.get('nextPage')) {
                requestNextPageButton = this.buildNextPageLink();
            }
        }

        return (
            <section>
                <header className={headerClasses}>
                    <OKBoxTitle value={headerTitle} inline={true} />
                    <div className="pull-right">
                        <OKButton modifier="task" onClick={this.handleToggleFiltersModal}>
                            <i className="icon-filtrar" />
                        </OKButton>
                    </div>
                    {filtersModal}
                    <div className="account-settlements__selected-filters">
                        {filterLabels}
                    </div>
                </header>
                {content}
                {requestNextPageButton}
            </section>
        );
    }
}

AccountSettlements.propTypes = {
    immScreen: PropTypes.object,
    immSettlements: PropTypes.object,
    accountId: PropTypes.string.isRequired,
    requestAccountsSettlements: PropTypes.func.isRequired,
    requestSettlementsNextPage: PropTypes.func.isRequired,
    setFilter: PropTypes.func.isRequired,
    clearFilter: PropTypes.func.isRequired
};

module.exports.constructor = AccountSettlements;
module.exports.AccountSettlements = connect(
    state => ({
        immScreen: state.screen,
        immSettlements: state.accountsSettlements,
    }),
    {
        requestAccountsSettlements: accountsSettlementsActions.requestSettlements,
        requestSettlementsNextPage: accountsSettlementsActions.requestSettlementsNextPage,
        setFilter: accountsSettlementsActions.setFilter,
        clearFilter: accountsSettlementsActions.clearFilter
    }
)(AccountSettlements);
